import Base from './Base';

class PayDebt extends Base {

    constructor () {
        super();
        this.endpoint = 'conekta';
        this.enableCoolDown = true;
    }

    generatePaymentLink = ( user_id  ) => {
        console.log("aqui entra a generar el payment link")
        return  fetch(this.getUrlEndpoint("payment-link/create/"+user_id),{
            method: 'POST',
            headers: this.headers
        }).then( response => response.json() )
    }
    
}

export default PayDebt;